// Typelizer digest fe1c30f14424971857ababc2dc13b9bd
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** PATCH /c/:company_id/ledger/documents/:document_id/expense_account */
  update: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/ledger/documents/:document_id/expense_account', params, options),
    method: 'patch',
  }),
}
